import { get, map, pick, pipe, getOr } from 'lodash/fp'
import { JobOffer } from '@/interfaces'

export const transformation: (data: any) => JobOffer = pipe([
  get('contentfulJobOffer'),
  (offer) => ({
    ...pick(['id', 'title', 'slug', 'node_locale'], offer),
    department: get('department', offer),
    locations: map('name', getOr([], 'location', offer)),
    types: map('name', getOr([], 'type', offer)),
    descriptions: map(
      (description: {}) => ({
        ...description,
        description: get('description.description', description),
      }),
      get('description', offer),
    ),
  }),
])

export default transformation
